import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TRANSLOCO_SCOPE } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { filter, Subject, takeUntil } from 'rxjs';
import { CommonUtilsService } from '../../services/commonutils/common-utils.service';

import { getCustomAppDetails$, getCustomOrganizationId$, getSubscribedApps$ } from '../../store/selectors';

@Component({
    selector: 'app-associate-bulk-dialog',
    templateUrl: './associate-bulk-dialog.component.html',
    styleUrls: ['./associate-bulk-dialog.component.scss'],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: '',
        },
    ],
    standalone: false,
})
export class AssociateBulkDialogComponent implements OnDestroy, OnInit {
    @Input() public selectedInstanceIds: any;

    private unSubscribe = new Subject<void>();
    public currentOrganizationId: string;
    public allSubscribedApps: any;
    public service: any;

    constructor(private store$: Store, private dialogRef: MatDialogRef<AssociateBulkDialogComponent>) {}

    closeModal = () => {
        this.dialogRef.close();
    };

    ngOnInit(): void {
        this.store$
            .select(getCustomOrganizationId$)
            .pipe(
                takeUntil(this.unSubscribe),
                filter(data => data !== undefined)
            )
            .subscribe(data => {
                this.currentOrganizationId = data;
            });
        this.store$
            .select(getSubscribedApps$)
            .pipe(
                takeUntil(this.unSubscribe),
                filter(data => data !== undefined)
            )
            .subscribe(data => {
                this.allSubscribedApps = CommonUtilsService.cloneObject(data)?.filter(app => app.assetType === 'ASSET');
            });
        this.store$
            .select(getCustomAppDetails$)
            .pipe(
                takeUntil(this.unSubscribe),
                filter(data => data !== undefined)
            )
            .subscribe(appDetails => {
                this.service = CommonUtilsService.cloneObject(appDetails);
            });
    }

    ngOnDestroy(): void {
        this.unSubscribe.next();
        this.unSubscribe.complete();
    }
}
